document.addEventListener('DOMContentLoaded', (event) => {
  const links = document.querySelectorAll('a');
  const currentDomain = window.location.hostname;

  links.forEach(link => {
      link.addEventListener('click', function (e) {
          const linkDomain = new URL(this.href).hostname;
          if (linkDomain && linkDomain !== currentDomain) {
              e.preventDefault();
              const userConfirmed = confirm("Sitesinden ayrılmak üzeresiniz. Devam etmek istiyor musunuz?");
              if (userConfirmed) {
                  window.location.href = this.href;
              }
          }
      });
  });
});
window.onload = function() {
    var h1Element = document.querySelector("h1.product-single__title span");
    var text = h1Element.innerHTML;
    var index = text.indexOf(' ');
    if (index !== -1) {
        h1Element.innerHTML = text.substring(0, index) + '<br>' + text.substring(index + 1);
    }
}